export default "__VITE_PUBLIC_ASSET__af1efd85__"